<template>
  <div v-if="showForm">
    <div id="overlay"></div>
    <!-- <div id='overlay' @click='$emit("close-form")'></div> -->
    <div id="form">
      <div class="column">
        <div class="schedule-form-levels">
          <div class="schedule-form-title">
            <h5 v-if="formType == 'edit'" class="form-header">Editar agenda</h5>
            <h5 v-if="formType == 'duplicate'" class="form-header">
              Duplicar agenda {{ scheduleName }}
              <!-- {{oldName}} -->
            </h5>
            <h5 v-if="formType == 'add'" class="form-header">
              Adicionar agenda
            </h5>
          </div>
          <b-form novalidate class="data-form" v-if="step == 1">
            <b-form-text v-show="form.NAME">Nome *</b-form-text>
            <b-form-input
              v-model="form.NAME"
              size="sm"
              placeholder="Nome *"
              maxlength="24"
              :state="nameState && notRepeatedName"
            />
            <b-form-invalid-feedback v-if="!nameState"
              >Campo inválido
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!notRepeatedName">
              Esse nome já está em uso
            </b-form-invalid-feedback>
            <b-form-input
              v-model="form.START_DATE"
              type="date"
              size="sm"
              :state="formType == 'edit' ? !!form.START_DATE : startDateState"
            />
            <b-form-invalid-feedback
              v-if="formType == 'edit' ? !form.START_DATE : !startDateState"
            >
              Campo inválido.
            </b-form-invalid-feedback>
            <b-form-input
              v-model="form.START_TIME"
              type="time"
              size="sm"
              :state="startTimeState"
            />
            <b-form-invalid-feedback v-if="!startTimeState">
              Campo inválido.
            </b-form-invalid-feedback>
            <center>
              <b-form-text> Dias de atuação: </b-form-text>
              <b-button-group>
                <b-btn
                  v-for="(d, index) in days"
                  :key="index"
                  @click="activeDay(index)"
                  :variant="selDays[index] == 1 ? '3v3' : 'danger'"
                  size="sm"
                >
                  {{ d.text }}
                </b-btn>
              </b-button-group>
            </center>
            <b-form-checkbox size="sm" v-model="ends" switch>
              Definir data de expiração?
            </b-form-checkbox>
            <span v-if="ends">
              <b-form-text> Expiração * </b-form-text>
              <b-form-input
                v-model="form.END_DATE"
                type="date"
                size="sm"
                :state="endDateState"
              />
              <b-form-input
                v-model="form.END_TIME"
                type="time"
                size="sm"
                :state="endDateState"
              />
              <b-form-invalid-feedback v-if="!endDateState">
                Campos inválidos.
              </b-form-invalid-feedback>
            </span>
            <b-form-checkbox size="sm" v-model="conditional" switch>
              Definir condição de operação?
            </b-form-checkbox>
            <span v-if="conditional" class="row">
              <div class="col-xs-12">
                <b-form-text>Sensor *</b-form-text>
                <searchable-select
                  v-model="form.FK_SENSOR"
                  :options="sensors"
                  text-field="NAME"
                  value-field="ID"
                  state="valid"
                  placeholder="Sensor"
                />
              </div>
              <div class="col-xs-12">
                <b-form-text>Medição do Sensor</b-form-text>
                <b-form-select
                  :disabled="form.FK_SENSOR === null"
                  v-model="form.POS_SENSOR"
                  size="sm"
                >
                  <template slot="first">
                    <option :value="null">Medição do sensor</option>
                  </template>
                  <option
                    v-for="(measure, index) in auxSensors.filter(
                      (e) => e.ID == form.FK_SENSOR
                    )"
                    :key="index"
                    :value="measure.POS"
                  >
                    {{ measure.NAME_TYPE }} ({{ measure.NAME_UNIT }})
                  </option>
                </b-form-select>
              </div>
              <div class="col-xs-4">
                <b-form-text>Ação</b-form-text>
                <b-form-select
                  :disabled="form.POS_SENSOR === null"
                  v-model="form.ACTION_SENSOR"
                  size="sm"
                >
                  <option v-for="opt in [0, 1]" :key="opt" :value="opt">
                    {{ opt ? "Direta" : "Inversa" }}
                  </option>
                </b-form-select>
              </div>
              <div class="col-xs-4">
                <b-form-text>Mínimo</b-form-text>
                <b-form-input
                  :disabled="form.POS_SENSOR === null"
                  v-model="form.MIN_SENSOR"
                  type="number"
                  size="sm"
                />
              </div>
              <div class="col-xs-4">
                <b-form-text>Máximo</b-form-text>
                <b-form-input
                  :disabled="form.POS_SENSOR === null"
                  v-model="form.MAX_SENSOR"
                  type="number"
                  size="sm"
                />
              </div>
              <p />
            </span>
            <b-form-checkbox size="sm" v-model="form.PEAK_HOUR_BLOCK" switch>
              Pausar no horário de ponta
            </b-form-checkbox>
            <div v-if="form.PEAK_HOUR_BLOCK" class="peak-hour-info">
              <em>
                {{ peakHourRange ? `Ponta: ${peakHourRange}. ` : "" }}Os setores que caem
                dentro da ponta não são irrigados: a agenda não é adiada. Janela
                em Configurações → Geral.
              </em>
            </div>
          </b-form>
          <div v-if="step == 2" class="content">
            <div class="content-description">
              <strong>Nome: </strong> {{ form.NAME.toUpperCase() }}<br />
              <strong>Início: </strong>
              {{ formatDateTime(form.START_DATE, form.START_TIME) }}<br />
              <strong>Dias de atuação:</strong> <span v-html="formatDays()" />
              <br />
              <span v-if="ends">
                <strong>Expira: </strong>
                {{ formatDateTime(form.END_DATE, form.END_TIME) }}<br />
              </span>
              <span v-if="conditional">
                <strong>Sensor:</strong>
                {{ sensors.filter((e) => e.ID == form.FK_SENSOR)[0].NAME
                }}<br />
                <strong>Medição:</strong>
                {{
                  auxSensors
                    .filter((e) => e.ID == form.FK_SENSOR)
                    .filter((e) => e.POS == form.POS_SENSOR)[0].NAME_TYPE
                }}<br />
                <strong>Ação</strong>
                {{ form.ACTION_SENSOR ? "Direta" : "Inversa" }}<br />
                <strong>Máxima: </strong> {{ form.MAX_SENSOR }}<br />
                <strong>Mínima: </strong> {{ form.MIN_SENSOR }}
              </span>
              <span v-if="form.PEAK_HOUR_BLOCK">
                <br v-if="conditional" />
                <strong>Pausa no horário de ponta</strong>
                {{ peakHourRange ? `(${peakHourRange})` : "" }}
              </span>
            </div>

            <div
              v-if="baseHistoryItems.length"
              class="accordion mb-2"
              role="tablist"
            >
              <b-card no-body class="mb-2">
                <div header-tag="div" role="tab">
                  <b-button
                    block
                    v-b-toggle.accordion-aa
                    variant="3v3"
                    class="w-100 d-flex align-items-center justify-content-between"
                  >
                    <div>Agendas Sugeridas</div>
                    <div class="arrow-suffix" />
                  </b-button>
                </div>
                <b-collapse
                  id="accordion-aa"
                  accordion="my-accordion-a"
                  role="tabpanel"
                  visible
                >
                  <b-card-text class="p-0">
                    <div class="d-flex flex-column">
                      <ul
                        class="schedule-management-details py-3 pl-2 pr-3 mb-0"
                      >
                        <li>
                          Tolerância agenda sugerida:
                          <strong>{{
                            forgivedDifferenceTimeManagement
                          }}</strong>
                          minutos.
                        </li>
                      </ul>
                      <b-table
                        striped
                        table-class="table-agn mb-0"
                        fixed
                        :tbody-tr-class="bladeTableClass"
                        outlined
                        :items="baseHistoryItems"
                        :fields="baseHistoryFields"
                      >
                        <template slot="TOTAL_TIME_SUGGESTED" slot-scope="row">
                          {{ row.item.TOTAL_TIME_SUGGESTED }}
                          <alert-circle-icon
                            v-if="row.item.SECTORS && row.item.SECTORS.length > 1"
                            title="Válvula usada em mais de um setor ao mesmo tempo"
                            class="text-danger"
                            style="cursor: pointer"
                            @click.native="openSectorsBreakdown(row.item)"
                          />
                        </template>
                      </b-table>
                    </div>
                  </b-card-text>
                </b-collapse>
              </b-card>
            </div>

            <b-btn block @click="backToGeneral" size="sm" class="pt-1"
              >Editar informações gerais de agenda
            </b-btn>
            <div class="row levels" v-show="!isLevelForm">
              <div class="schedule-form-toolbar row">
                <div class="col-xs-6">
                  <b-form-select
                    @change="checkMenu"
                    size="sm"
                    v-model="typeOpt"
                  >
                    <option value="lvl">Nível</option>
                    <!-- <option value="sub" :disabled="!levels.length">
                      Subnível ao nível
                    </option> -->
                  </b-form-select>
                </div>
                <div class="col-xs-6">
                  <b-form-select
                    size="sm"
                    v-model="selectedLevelPosition"
                    :options="levelPositionsSelector"
                  />
                </div>
                <div class="col-xs-12 pt-1">
                  <b-btn
                    block
                    size="sm"
                    rounded
                    variant="secondary"
                    class="buttons-icons"
                    @click.stop="
                      levelCreator('add', selectedLevelPosition, typeOpt)
                    "
                  >
                    <plus-icon />
                    <span>Adicionar nível</span>
                  </b-btn>
                </div>
              </div>

              <div class="col-xs-12">
                <schedule-levels
                  v-if="form.sublevels.length"
                  :schedule="form.NAME"
                  :agn-start="form.START_TIME"
                  :levels="form.sublevels"
                  :where-to-scroll="whereToScroll"
                  :flows="flows"
                  :hectare="hectare"
                  :show-form="isLevelForm"
                  @set-level="onSetLevel"
                  @level-remove="onLevelRemove"
                  @level-with-ferti-edit="onLevelWithFertiEdit"
                  @level-edit="onLevelEdit"
                  @ferti-add="onFertiAdd"
                  @update-total-duration-by-valve="updateTotalDurationByValve"
                  @ferti-edit="onFertiEdit"
                  @ferti-remove="onFertiRemove"
                  @duplicate="addNewLevel"
                  editmode
                />
                <span v-else>Não há níveis cadastrados para esta agenda.</span>
              </div>
            </div>
            <div class="row levels" v-show="isLevelForm">
              <strong class="col-xs-12 center-xs mt-3 mb-4 fw-bold text-dark">{{
                levelPageTitle
              }}</strong>

              <div class="title-section px-2 pb-2">
                Selecione as válvulas do nível atual:
              </div>
              <b-btn
                block
                size="sm"
                rounded
                @click="showFormEquipments"
                variant="info"
                >Adicionar ou remover Válvulas</b-btn
              >
              <div class="selected-box p-0 m-0 w-100">
                <div
                  class="selected-item"
                  v-for="(sel, index) in selValves"
                  :key="index"
                >
                  {{ sel.NAME }}
                  <span class="selected-property" v-if="sel.AREA"
                    >{{ sel.AREA }}hA</span
                  >
                  <!-- <div v-if="!isFerti" class="row">
                    <div class="col-xs-6 selected-property">
                      Volume previsto:
                      {{ calcHistoricVolPerValve(sel) || "?" }}m³<br />
                      Lâmina prevista:
                      {{
                        calcVolBlade(
                          calcHistoricVolPerValve(sel),
                          sel,
                          sel.AREA,
                          hectare
                        ) || "?"
                      }}mm
                    </div>
                    <div class="col-xs-6 selected-property">
                      Volume ideal:
                      {{ calcIdealVolPerValve(sel) || "?" }}m³<br />
                      Lâmina ideal:
                      {{
                        calcVolBlade(
                          calcIdealVolPerValve(sel),
                          sel,
                          sel.AREA,
                          hectare
                        ) || "?"
                      }}mm
                    </div>
                    <div
                      class="col-xs-12 selected-property"
                      v-if="
                        calcHistoricVolPerValve(sel) &&
                        calcIdealVolPerValve(sel)
                      "
                    >
                      Eficiência:
                      {{
                        (
                          (calcHistoricVolPerValve(sel) /
                            calcIdealVolPerValve(sel)) *
                          100
                        ).toFixed(2)
                      }}%
                    </div>
                  </div> -->
                </div>
              </div>
              <span class="ferti-error p-2">
                Selecionadas: {{ selValves.length }} de
                {{ selectedValves }}
                <br />
                <span v-if="isFerti && selValves.length > 1">
                  Fertirrigação aceita apenas uma válvula por subnível
                </span>
                <span v-if="isFerti && !selValves.length">
                  Não há válvula selecionada para ferti
                </span>
              </span>

              <b-form novalidate class="px-2">
                <div class="title-section">
                  Defina a duração, em minutos, do nível:
                </div>
                <div class="row">
                  <div :class="`col-xs-9`">
                    <b-form-text>Duração (min) *</b-form-text>
                    <b-form-input
                      v-model="levelForm.TIME"
                      type="number"
                      :min="0"
                      :max="isFerti ? maxFertiDuration : null"
                      size="sm"
                      :disabled="allDay"
                      :state="levelDurationState"
                      @change="changeFertiDuration"
                    />
                    <span
                      class="ferti-error"
                      v-if="isFerti && levelForm.TIME > maxFertiDuration"
                    >
                      Duração máxima permitida: {{ maxFertiDuration }} min
                    </span>
                    <span
                      class="ferti-error"
                      v-if="isFerti && alertFertiDuration"
                    >
                      Soma da duração de subníveis de ferti pode estar superando
                      a duração do subnível de irrigação.
                    </span>
                  </div>
                  <div :class="`col-xs-3`">
                    <b-form-text>Dia todo?</b-form-text>
                    <b-form-checkbox
                      v-model="allDay"
                      switch
                      @change="allDaySelected"
                    />
                  </div>
                </div>
                <div v-if="isFerti">
                  <b-form-text>Volume (l)</b-form-text>
                  <b-form-input
                    v-model="levelForm.VOLUME"
                    type="number"
                    :state="levelDurationVolumeState"
                    @change="changeFertiVolume"
                    :min="0"
                    size="sm"
                    :max="showMaxVolume"
                  />
                  <span
                    class="ferti-error"
                    v-if="isFerti && alertFertiVolume && levelForm.TIME > 0"
                  >
                    Volume máximo permitido: {{ showMaxVolume }}(l)
                  </span>
                </div>

                <div v-if="!isFerti">
                  <b-form-text>Volume de corte (litros)</b-form-text>
                  <b-form-input
                    v-model="levelForm.VOLUME"
                    type="number"
                    :min="0"
                    size="sm"
                  />
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
      <b-modal
        ref="formEquipments"
        centered
        hide-header
        hide-footer
        size="sm"
        @hide="hideForm"
      >
        <b-btn
          size="sm"
          block
          class="col-xs-12"
          @click="$refs.pumpFilter.show()"
        >
          Filtro: {{ pumpFilterTitle }}
        </b-btn>
        <b-modal ref="pumpFilter" centered hide-header hide-footer>
          <div class="equipment-table">
            <b-list-group>
              <b-list-group-item
                button
                @click="filterByPump()"
                :disabled="pumpFilterTitle == 'Todas as válvulas'"
              >
                Todas as válvulas
              </b-list-group-item>
              <b-list-group-item
                button
                v-if="
                  valvesReq.length &&
                  valvesReq.filter((e) => e.NAME == 'INTERVALO').length
                "
                @click="selectInterval"
              >
                Intervalo
              </b-list-group-item>
              <!-- <b-dropdown-divider v-show='pumps.length' /> -->
              <b-list-group-item
                button
                id="pumps"
                header="Filtrar por bomba"
                v-for="p in pumps"
                :key="p"
                @click="filterByPump(p)"
                :disabled="pumpFilterTitle == p"
              >
                {{ p }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-modal>
        <h6>Selecionadas: {{ selValves.length }}</h6>
        <div class="equipment-table">
          <spinner v-if="loadingValves" />
          <b-table
            v-if="!loadingValves"
            striped
            small
            borderless
            hover
            responsive
            :items="listValves"
            :fields="valveFields"
            ref="btable"
          >
            <template slot="HEAD_CHECK">
              <!-- @click.native.prevent="toggleAllValves" -->
              <b-form-checkbox
                @change="toggleAllValves"
                v-model="allValveSelected"
              ></b-form-checkbox>
            </template>
            <template slot="HEAD_NAME"> Selecionar tudo </template>
            <template slot="CHECK" slot-scope="row">
              <b-form-checkbox
                :value="row.item"
                v-model="selValves"
              ></b-form-checkbox>
            </template>
            <template slot="NAME" slot-scope="row">
              {{ row.item.NAME }}
            </template>
          </b-table>
        </div>
        <b-btn
          v-if="$refs.formEquipments"
          block
          size="sm"
          @click="closeFormEquipments"
          >Voltar</b-btn
        >
      </b-modal>
      <b-modal
        ref="formError"
        no-close-on-backdrop
        centered
        hide-header
        hide-footer
        body-bg-variant="warning"
      >
        <h5>Atenção!</h5>
        <div class="row">
          <div class="col-xs-12">
            Não é possível seguir para edição de níveis porque
          </div>
          <div class="col-xs-3 center-xs">
            <alert-icon title="" style="font-size: 3em" />
          </div>
          <ul class="col-xs-9">
            <li v-for="err in errors" :key="err">{{ err }}</li>
          </ul>
        </div>
        <b-btn
          v-if="$refs.formError"
          block
          variant="light"
          size="sm"
          @click="$refs.formError.hide"
          >Vou corrigir</b-btn
        >
      </b-modal>
      <footer id="footer">
        <!-- block -->
        <b-btn
          size="sm"
          v-show="step == 2 && isLevelForm"
          @click="cancelLevelPage"
          variant="outline-secondary"
        >
          Cancelar {{ levelType }}
        </b-btn>
        <!-- block -->
        <b-btn
          size="sm"
          v-show="!isLevelForm"
          @click="cancelScheduleForm"
          variant="outline-secondary"
          class="ml-2 mr-1"
        >
          Cancelar
        </b-btn>
        <!-- block -->
        <b-btn
          variant="3v3"
          v-show="step == 1"
          @click="checkForm"
          size="sm"
          class="ml-1 mr-2"
        >
          Níveis de irrigação
        </b-btn>
        <!-- block -->
        <b-btn
          variant="3v3"
          v-show="step == 2 && !isLevelForm"
          @click="submit"
          size="sm"
          class="ml-1 mr-2"
          :disabled="disableBtnSubmit"
        >
          Salvar
        </b-btn>
        <!-- block -->
        <b-btn
          variant="3v3"
          v-show="step == 2 && isLevelForm"
          :disabled="
            !selValves.length ||
            (hasFerti && selValves.length > 1) ||
            alertFertiDuration ||
            !levelDurationState ||
            (isFerti && !levelDurationVolumeState)
          "
          @click="levelAdd(typeOpt)"
          size="sm"
          class="ml-1 mr-2"
        >
          Salvar {{ levelType }}
        </b-btn>
      </footer>
    </div>

    <b-modal
      ref="sectorsBreakdown"
      centered
      hide-footer
      :title="`Recomendação por setor — ${sectorsBreakdownValve}`"
    >
      <p class="mb-3">
        A válvula <strong>{{ sectorsBreakdownValve }}</strong> é utilizada em mais de um
        setor ao mesmo tempo. A recomendação da agenda usa o setor de maior área; os demais
        ficam abaixo para conferência. Sugerimos que uma válvula seja utilziada em apenas um setor ativo.
      </p>
      <b-table
        striped
        outlined
        table-class="mb-0"
        :items="sectorsBreakdown"
        :fields="sectorsBreakdownFields"
      />
    </b-modal>
  </div>
</template>

<script>
import calcManagement from "@/mixins/calcManagement";
import { forgivedDifferenceTimeManagement } from "../constants";
import {
  getManagementClassificationSchedule,
  getValvesTotalDurationByLevels,
  calcVolPerValve,
} from "../helpers";
import {
  testName,
  notRepeatedName,
} from "@/pages/components/regist/form-functions";
import { schedules, management, peakHourConfig } from "@/api";
import moment from "moment";
import SearchableSelect from "@/pages/components/shared/SearchableSelect.vue";
export default {
  name: "schedule-form",
  mixins: [calcManagement],
  components: {
    SearchableSelect,
  },
  props: {
    showForm: Boolean,
    formType: String,
    oldName: String,
    alreadyUsedNames: Array,
    itemToEdit: [Number, Object],
    sensors: Array,
    auxSensors: Array,
    days: Array,
    flows: Object,
    hectare: Number,
  },
  data() {
    return {
      step: 1,
      previewManagementData: [],
      afterAddLevelManagementData: [],
      sectorsBreakdown: [],
      sectorsBreakdownValve: "",
      sectorsBreakdownFields: [
        { key: "NAME", label: "Setor" },
        { key: "AREA", label: "Área (ha)", class: "text-aln-center" },
        { key: "BLADE_SUGGESTION", label: "Lâmina (mm)", class: "text-aln-center" },
        { key: "TIME_SUGGESTED", label: "Tempo sugerido (min)", class: "text-aln-center" },
      ],
      errors: [],
      dinamicValvesDurations: {},
      forgivedDifferenceTimeManagement,
      alertFertiDuration: false,
      alertFertiVolume: false,
      selectedItem: {},
      form: {
        NAME: "",
        START_DATE: "",
        START_TIME: "",
        END_DATE: "",
        END_TIME: "",
        ACTIVITY_DAYS: 127,
        LEVELS: null,
        sublevels: [],
        FK_SENSOR: null,
        POS_SENSOR: null,
        ACTION_SENSOR: null,
        MAX_SENSOR: null,
        MIN_SENSOR: null,
        PEAK_HOUR_BLOCK: false,
      },
      peakHourRange: "",
      selDays: [1, 1, 1, 1, 1, 1, 1],
      ends: false,
      conditional: false,
      agnlevel: 0, //por padrão zero para adição
      levelType: "",
      typeMenu: [
        { value: "lvl", text: "Nível" },
        // { value: "sub", text: "Subnível ao nível" },
      ],
      levelPositionsSelector: [],
      typeOpt: "lvl",
      selectedLevelPosition: null,
      levels: [],
      isLevelForm: false,
      levelPageTitle: null,
      isFerti: false,
      isFertiAdd: false,
      allDay: false,
      levelForm: {
        TIME: 0,
        VOLUME: 0,
        MIN_TIME: 0,
        ADVANCE_TIME: 0,
      },
      hasFerti: false,
      sublevel: false,
      whereToScroll: "",
      loadingValves: true,
      selValves: [],
      allValveSelected: false,
      valvesReq: [],
      valves: [],
      schedules: [],
      valveFields: [
        {
          key: "CHECK",
          label: "",
        },
        {
          key: "NAME",
          label: "",
        },
      ],
      pumps: [],
      pumpFilterTitle: "Todas as válvulas",
      updateVolume: 0,
      updateDepth: 0,
      calculatePulseTime: "pulse",
      isSelectDisabled: true,
      inputsLabels: ["ideal", "ideal"],
      selectOptions: [
        { value: "pulse", text: "Tempo especificado" },
        { value: "ideal", text: "Volume ou lâmina ideais" },
        { value: "estimated", text: "Volume ou lâmina previstos" },
      ],
      listValves: [],
      oldSelected: [],
      disableBtnSubmit: false,
    };
  },
  mounted() {
    // Só informativo: sem a faixa o formulário funciona igual.
    peakHourConfig
      .get()
      .then((ret) => {
        if (ret && ret.START_TIME && ret.END_TIME)
          this.peakHourRange = `${ret.START_TIME.slice(0, 5)} - ${ret.END_TIME.slice(0, 5)}`;
      })
      .catch(() => {});
  },
  watch: {
    async selectedValvesUnique(newValue, oldValue) {
      try {
        if (!newValue.length) {
          this.previewManagementData = [];
          return;
        }

        const managementData =
          await management.getScheduleManagementRecomentation({
            byIdValves: newValue.map((valve) => valve.ID),
          });

        const managementSuggestedSchedules = managementData
          .filter(
            (manag) => manag.BLADE_SUGGESTION || manag.BLADE_SUGGESTION === 0
          )
          .map((manag) => {
            const {
              BLADE_SUGGESTION,
              AREA,
              TRANSMISSIVITY,
              NAME,
              ALL_AGN_DURATION,
              SECTORS,
            } = manag;

            const { MIN_PER_VOL } = newValue.find((val) => val.ID === manag.ID);

            const VOLUME_SUGGESTED = this.lam2vol(
              BLADE_SUGGESTION,
              AREA,
              TRANSMISSIVITY
            );
            const TIME_SUGGESTED = Math.floor(VOLUME_SUGGESTED / MIN_PER_VOL);

            return {
              NAME,
              TOTAL_TIME_CURRENT: ALL_AGN_DURATION,
              TOTAL_TIME_SUGGESTED: TIME_SUGGESTED,
              SECTORS: (SECTORS || []).map((sector) => ({
                ...sector,
                TIME_SUGGESTED: Math.floor(
                  this.lam2vol(
                    sector.BLADE_SUGGESTION,
                    sector.AREA,
                    sector.TRANSMISSIVITY
                  ) / MIN_PER_VOL
                ),
              })),
            };
          });

        this.previewManagementData = managementSuggestedSchedules;
      } catch (e) {
        console.error(e);
      }
    },
    updateVolume: function (value) {
      let valve = this.selValves[0];
      let flow = 0;
      if (this.calculatePulseTime === "estimated") {
        flow = this.flows[valve.ID];
      } else {
        flow = (valve.MAX_FLOW + valve.MIN_FLOW) / 2;
      }
      if (flow > 0) {
        let flowPerMinute = flow / 60;
        let time = value / flowPerMinute;
        this.levelForm.TIME = Math.ceil(time);
      }
    },
    updateDepth: function (value) {
      let valve = this.selValves[0];
      let flow = 0;
      if (this.calculatePulseTime === "estimated") {
        flow = this.flows[valve.ID];
      } else {
        flow = (valve.MAX_FLOW + valve.MIN_FLOW) / 2;
      }
      if (flow > 0) {
        let flowPerMinute = flow / 60;
        let time = (value * valve.AREA * this.hectare) / 1000 / flowPerMinute;
        this.levelForm.TIME = Math.ceil(time);
      }
    },
    calculatePulseTime: function (value) {
      this.calculatePulseTime = value;
      if (this.calculatePulseTime === "estimated")
        this.inputsLabels = ["previsto", "prevista"];
      else {
        this.inputsLabels = ["ideal", "ideal"];
      }
    },
    selValves(oldValue, newValue) {
      // Condição para guardar os valores das válvulas selecionadas no checkbox quando as opções dos checkbox estiverem todas
      // desmarcadas, com isso será possível restringir a troca das válvulas somente por os mesmos modelos quando for editar
      // uma agenda com ferti.
      if (!oldValue.length && newValue.length) {
        this.oldSelected = newValue;
      } else {
        this.oldSelected = [];
      }

      this.allValveSelected =
        this.selValves.length && this.selValves.length == this.valves.length;
      if (this.selValves.length !== 1) {
        this.calculatePulseTime = "pulse";
        this.isSelectDisabled =
          this.selValves.length !== 1 || this.levelForm.TIME === 1440;
      } else {
        this.isSelectDisabled =
          this.selValves.length !== 1 || this.levelForm.TIME === 1440;
      }
    },
    ends() {
      if (!this.ends) {
        this.form.END_DATE = "";
        this.form.END_TIME = "";
      }
    },
    conditional() {
      if (!this.conditional) {
        this.form.FK_SENSOR = null;
        this.form.POS_SENSOR = null;
        this.form.ACTION_SENSOR = null;
        this.form.MAX_SENSOR = null;
        this.form.MIN_SENSOR = null;
      } else {
        if (this.formType == "add") {
          this.form.ACTION_SENSOR = 0;
        }
      }
    },
    showForm(newVal, oldVal) {
      const formState = {
        OPEN: newVal === true && oldVal === false,
        CLOSE: newVal === false,
      };
      this.selValves = [];
      this.clearManagementScheduleTemp();
      this.selectedItem = JSON.parse(JSON.stringify(this.itemToEdit));

      if (formState.CLOSE) {
        this.disableBtnSubmit = false;
        this.resetForm();
        return;
      }
      // else if(this.duplicate){}
      if (formState.OPEN) {
        this.step = 1;

        if (this.formType == "add") {
          this.resetForm();
          return;
        }

        // Evitar trazer informações das agendas com dados desincronizados
        // Ex: subníveis e níveis com posições erradas
        this.organizeSelectedSchedule(this.selectedItem);

        if (this.formType == "duplicate") {
          this.form.NAME = "";
          this.ends = false;
          if (this.selectedItem.FK_SENSOR) {
            this.conditional = true;
            this.form.FK_SENSOR = this.selectedItem.FK_SENSOR;
            this.form.POS_SENSOR = this.selectedItem.POS_SENSOR;
            this.form.ACTION_SENSOR = this.selectedItem.ACTION_SENSOR;
            this.form.MIN_SENSOR = this.selectedItem.MIN_SENSOR;
            this.form.MAX_SENSOR = this.selectedItem.MAX_SENSOR;
          } else this.conditional = false;
          this.form.PEAK_HOUR_BLOCK = !!Number(this.selectedItem.PEAK_HOUR_BLOCK);
          this.organizeSublevelsToShow(this.selectedItem);
          this.pumpFilterTitle = "Todas as válvulas";
        } else if (this.formType == "edit") {
          this.form.ID = this.selectedItem.ID;
          this.form.NAME = this.selectedItem.NAME;
          this.form.ACTIVITY_DAYS = this.selectedItem.ACTIVITY_DAYS;
          this.form.START_TIME = this.selectedItem.START_TIME;
          this.form.START_DATE = this.selectedItem.START_DATE.split("T")[0];
          if (
            this.selectedItem.END_DATE &&
            this.selectedItem.END_DATE.indexOf("0000-00-00") < 0 &&
            this.selectedItem.END_TIME
          ) {
            this.ends = true;
            this.form.END_DATE = this.selectedItem.END_DATE.split("T")[0];
            this.form.END_TIME = this.selectedItem.END_TIME;
          } else this.ends = false;
          if (this.selectedItem.FK_SENSOR) {
            this.conditional = true;
            this.form.FK_SENSOR = this.selectedItem.FK_SENSOR;
            this.form.POS_SENSOR = this.selectedItem.POS_SENSOR;
            this.form.ACTION_SENSOR = this.selectedItem.ACTION_SENSOR;
            this.form.MIN_SENSOR = this.selectedItem.MIN_SENSOR;
            this.form.MAX_SENSOR = this.selectedItem.MAX_SENSOR;
          } else this.conditional = false;
          this.form.PEAK_HOUR_BLOCK = !!Number(this.selectedItem.PEAK_HOUR_BLOCK);
          this.organizeSublevelsToShow(this.selectedItem);
          this.activityDays();
          this.pumpFilterTitle = "Todas as válvulas";
          this.step = 2;
        }
      }
    },
  },
  computed: {
    allValvesNames() {
      return this.itemToEdit.sublevels
        .map((sublevel) => sublevel.ELEMENTS[0])
        .map((el) => el.NAME);
    },
    selectedValvesUnique() {
      if (!this.selValves) {
        return [];
      }

      return this.selValves
        .filter(
          (valve) =>
            ![
              ...this.afterAddLevelManagementData,
              ...this.baseSelectedValvesManagementSchedule,
            ]
              .map((valveHistory) => valveHistory.NAME)
              .includes(valve.NAME)
        )
        .map((valve) => {
          return {
            ID: valve.ID,
            NAME: valve.NAME,
            MIN_PER_VOL: Number(this.calcVolPerValve(valve, 1, this.flows)),
          };
        });
    },
    valvesAndDurationFromStart() {
      return this.getValvesTotalDurationByLevels(this.itemToEdit.sublevels);
    },
    baseHistoryFields() {
      return [
        { key: "NAME", label: "Válvula" },
        {
          key: "TOTAL_TIME_CURRENT",
          label: "Total Atual\n(min)",
          class: "text-aln-center",
        },
        {
          key: "TOTAL_TIME_SUGGESTED",
          label: "Total Sugerido\n(min)",
          class: "text-aln-center",
        },
      ];
    },
    baseSelectedValvesManagementSchedule() {
      if (!this.itemToEdit) {
        return [];
      }

      let uniqueValves = [];

      this.itemToEdit.management_infos.forEach((valve) => {
        if (
          !uniqueValves.find((uniqueValve) => uniqueValve.NAME === valve.NAME)
        ) {
          let { TOTAL_TIME_CURRENT, TOTAL_TIME_SUGGESTED, NAME, SECTORS } = valve;

          const startedTotalTimeValveSchedule =
            this.valvesAndDurationFromStart[NAME] || 0;
          const dinamicTotalTimeValveSchedule =
            this.dinamicValvesDurations[NAME] || 0;

          TOTAL_TIME_CURRENT =
            TOTAL_TIME_CURRENT -
            startedTotalTimeValveSchedule +
            dinamicTotalTimeValveSchedule;

          uniqueValves.push({
            TOTAL_TIME_CURRENT,
            TOTAL_TIME_SUGGESTED,
            NAME,
            SECTORS,
          });
        }
      });

      return uniqueValves.filter((valve) =>
        this.allValvesNames.includes(valve.NAME)
      );
    },
    baseHistoryItems() {
      return [
        ...this.baseSelectedValvesManagementSchedule,
        ...this.previewManagementData,
        ...this.afterAddLevelManagementData,
      ].filter((valve) => {
        if (
          this.levelForm.selected &&
          this.levelForm.selected.ELEMENTS &&
          this.levelForm.selected.ELEMENTS[0]
        ) {
          return valve.NAME === this.levelForm.selected.ELEMENTS[0].NAME;
        }

        return valve;
      });
    },
    scheduleName() {
      if (this.selectedItem.NAME.length > 12) {
        return this.selectedItem.NAME.substring(0, 12) + "...";
      }
      return this.selectedItem.NAME;
    },
    selectedValves() {
      return this.listValves.length < this.selValves.length
        ? this.selValves.length
        : this.listValves.length;
    },
    nameState() {
      return testName(this.form.NAME);
    },
    notRepeatedName() {
      return notRepeatedName(
        this.alreadyUsedNames,
        this.form.NAME,
        this.formType,
        this.oldName
      );
    },
    startTimeState() {
      return !!this.form.START_TIME;
    },
    endDateState() {
      if (this.ends)
        return (
          !!this.form.END_DATE &&
          !!this.form.END_TIME &&
          `${this.form.END_DATE} ${this.form.END_TIME}` >
            `${this.form.START_DATE} ${this.form.START_TIME}`
        );
      else return true;
    },
    startDateState() {
      return this.form.START_DATE > "2010-01-01";
    },
    checkConditional() {
      if (!this.conditional) {
        this.form.FK_SENSOR = null;
        this.form.POS_SENSOR = null;
        this.form.ACTION_SENSOR = null;
        this.form.MAX_SENSOR = null;
        this.form.MIN_SENSOR = null;
        return true;
      } else if (
        this.form.FK_SENSOR &&
        this.form.POS_SENSOR !== null &&
        this.form.ACTION_SENSOR !== null &&
        (this.form.MAX_SENSOR === 0 || this.form.MAX_SENSOR) &&
        (this.form.MIN_SENSOR === 0 || this.form.MIN_SENSOR)
      ) {
        this.form.MAX_SENSOR = Number(this.form.MAX_SENSOR);
        this.form.MIN_SENSOR = Number(this.form.MIN_SENSOR);
        return true;
      } else return;
    },
    levelDurationState() {
      const validDuration =
        this.levelForm.TIME > 0 && this.levelForm.TIME % 1 == 0;
      if (this.isFerti) {
        return validDuration && this.levelForm.TIME <= this.maxFertiDuration;
      }
      return validDuration;
    },
    levelDurationVolumeState() {
      return this.levelForm.VOLUME <= this.showMaxVolume;
    },
    maxFertiDuration() {
      return 240;
    },
    showMaxVolume() {
      const rateBasedMax =
        this.levelForm.TIME <= 3
          ? 45 * this.levelForm.TIME
          : 50 * this.levelForm.TIME;
      return Math.min(rateBasedMax, 4095);
    },
    isVolumeDisabled: function () {
      if (this.selValves.length === 1) {
        let valve = this.selValves[0];
        let isIdealFlowNull = (valve.MAX_FLOW + valve.MIN_FLOW) / 2 === 0;
        if (["pulse", "ideal"].includes(this.calculatePulseTime))
          return isIdealFlowNull;
        else return !this.flows[valve.ID];
      } else return true;
    },
    isDepthDisabled: function () {
      if (this.selValves.length === 1 && this.selValves[0].AREA) {
        let valve = this.selValves[0];
        let isIdealFlowNull = (valve.MAX_FLOW === valve.MIN_FLOW) === 0;
        if (["pulse", "ideal"].includes(this.calculatePulseTime))
          return isIdealFlowNull;
        else return !this.flows[valve.ID];
      } else return true;
    },
  },
  methods: {
    calcVolPerValve,
    getValvesTotalDurationByLevels,
    getManagementClassificationSchedule,
    clearManagementScheduleTemp() {
      this.afterAddLevelManagementData = [];
      this.previewManagementData = [];
    },
    updateTotalDurationByValve(valvesAndDuration) {
      this.dinamicValvesDurations = valvesAndDuration;
    },
    openSectorsBreakdown(item) {
      this.sectorsBreakdownValve = item.NAME;
      this.sectorsBreakdown = (item.SECTORS || []).map((s) => ({
        NAME: s.NAME,
        AREA: s.AREA,
        BLADE_SUGGESTION:
          s.BLADE_SUGGESTION || s.BLADE_SUGGESTION === 0
            ? Number(s.BLADE_SUGGESTION).toFixed(2)
            : "-",
        TIME_SUGGESTED: s.TIME_SUGGESTED,
      }));
      this.$refs.sectorsBreakdown.show();
    },
    bladeTableClass(item, type) {
      if (!item || type !== "row") return;

      return this.getManagementClassificationSchedule(
        item.TOTAL_TIME_CURRENT - item.TOTAL_TIME_SUGGESTED
      );
    },
    changeFertiDuration() {
      if (
        this.sublevel &&
        this.isFerti &&
        this.form.sublevels &&
        this.form.sublevels.length
      ) {
        // verifica se duração + avanço do SUBNÍVEL selecionado é menor que a soma da duração + avanço dos NÍVEIS DE FERTI
        // a duração de um nível de ferti não pode ser maior que a duração do subnível ao qual está atrelado
        if ((this.levelForm.TIME && this.levelForm.TIME > 0) || this.allDay) {
          let index = this.levelForm.levelIndex;
          let sublevel = this.form.sublevels[index];
          let realTotalDuration = this.calcDuration(
            sublevel.duration.TIME,
            sublevel.duration.ADVANCE_TIME
          );
          let fertiDurations = [];
          sublevel.FERTI.map((e) =>
            fertiDurations.push(Number(e.duration.TIME))
          );
          let sumFertis = fertiDurations.reduce((res, e) => res + e, 0);
          let editDuration = this.levelForm.TIME; //nova duração
          if (!this.isFertiAdd) {
            // subtrair a antiga duração do nível caso seja edição
            sumFertis -= this.levelForm.selected.duration.TIME;
          }
          if (sumFertis + parseInt(editDuration) > realTotalDuration)
            return (this.alertFertiDuration = true);
        }
      }
      return (this.alertFertiDuration = false);
    },
    changeFertiVolume() {
      if (this.levelForm.TIME <= 3) {
        //45L/MIN
        return (this.alertFertiVolume = true);
      }
      if (this.levelForm.TIME >= 4) {
        //50L/MIN
        return (this.alertFertiVolume = true);
      }
      return (this.alertFertiVolume = false);
    },
    organizeSelectedSchedule(form) {
      const levels = form.sublevels;

      levels.forEach((formLevel, levelIndex) => {
        const levelPosition = levelIndex + 1;

        formLevel.LEVEL = levelPosition;
        formLevel.GROUP = levelPosition;
        // Organizar os elements (equipamentos atrelados ao nível)
        // atualiza para deixar a posição dos níveis
        formLevel.ELEMENTS.forEach((element) => {
          element.LEVEL = levelPosition;
          element.GROUP = levelPosition;
        });

        formLevel.FERTI.forEach((fertiLevel) => {
          fertiLevel.LEVEL = levelPosition;
        });
      });
    },
    addNewLevel(groupIndex) {
      let copy = JSON.parse(JSON.stringify(this.form.sublevels[groupIndex]));

      let currentLevel = this.selectedLevelPosition;
      let levels = this.levelPositionsSelector;
      let numOfLevels = levels.length;
      // Duplicar selecionando o nível por select
      let isLast = currentLevel == levels[numOfLevels - 1];
      this.agnlevel++;
      if (isLast) {
        copy.LEVEL = this.selectedLevelPosition;
        copy.GROUP = this.selectedLevelPosition;
        if (copy.FERTI) {
          copy.FERTI.forEach((ferti) => {
            ferti.LEVEL = this.selectedLevelPosition;
            ferti.GROUP = null;
          });
        }
        if (copy.ELEMENTS) {
          copy.ELEMENTS.forEach((el) => {
            el.LEVEL = this.selectedLevelPosition;
            // el.LEVEL++;
            el.GROUP = this.selectedLevelPosition;
            // el.GROUP++;
          });
        }
        // this.agnlevel++;
        // this.form.sublevels.splice(copy);
        this.levels.push(copy);
      } else {
        let lvls = this.levels.map((e) => e.LEVEL);
        let newIndex = lvls.indexOf(currentLevel);
        copy.LEVEL = currentLevel;
        copy.GROUP = currentLevel;
        this.levels.splice(newIndex, 0, copy);
        this.levels.forEach((e, i) => {
          // Se for adicionar um novo nível

          if (newIndex === i) {
            if (e.ELEMENTS) {
              e.ELEMENTS.forEach((el) => {
                el.LEVEL = currentLevel;
                el.GROUP = currentLevel;
              });
            }
            if (e.FERTI) {
              e.FERTI.forEach((ferti) => {
                ferti.LEVEL = currentLevel;
                ferti.GROUP = null;
              });
            }
          }
          if (i > newIndex) {
            e.LEVEL++;
            e.GROUP++;
            if (e.ELEMENTS) {
              e.ELEMENTS.forEach((el) => {
                el.LEVEL = e.LEVEL;
                el.GROUP = e.LEVEL;
              });
            }
            if (e.FERTI) {
              e.FERTI.forEach((ferti) => {
                ferti.LEVEL = e.LEVEL;
                ferti.GROUP = null;
              });
            }
          }
        });
        this.whereToScroll = newIndex ? `group${newIndex}` : "";
      }

      this.form.sublevels = this.levels;
      this.resetMenus();
    },
    hideForm() {
      this.valvesItemsFormCheckbox();
    },
    cancelScheduleForm() {
      this.selectedItem = this.itemToEdit;
      this.$emit("close-form");
    },
    showFormEquipments() {
      this.$refs.formEquipments.show();
      this.valvesItemsFormCheckbox();
    },
    closeFormEquipments() {
      this.$refs.formEquipments.hide();
    },
    showValvesWithSamePumpName(regexFIR) {
      if (this.selValves.length === 0) {
        let items = [];
        this.oldSelected.forEach((e, i) => {
          let v = this.valves.filter((v) => {
            if (v.PUMP_NAME === e.PUMP_NAME && !v.NAME_MODEL.match(regexFIR)) {
              return true;
            }
            return false;
          });
          items = v;
        });
        return items;
      } else {
        let items = [];
        this.selValves.forEach((e, i) => {
          let v = this.valves.filter((v) => {
            if (v.PUMP_NAME === e.PUMP_NAME && !v.NAME_MODEL.match(regexFIR)) {
              return true;
            }
            return false;
          });
          items = v;
        });
        return items;
      }
    },
    filterValvesWithNameModel(regexFIR, isFerti) {
      if (isFerti) {
        let filteredValves = this.valves.filter((v) => {
          if (v.NAME_MODEL.match(regexFIR)) {
            return true;
          }
          return false;
        });
        return filteredValves;
      }
      let filteredValves = this.valves.filter((v) => {
        if (v.NAME_MODEL.match(regexFIR)) {
          return false;
        }
        return true;
      });
      return filteredValves;
    },
    valvesItemsFormCheckbox() {
      let regexFIR = /FIR/g;
      if (this.formType === "edit" || this.formType === "duplicate") {
        // Listar válvulas no editar subnível que possuem os mesmos PUMP_NAME's
        if (
          this.hasFerti &&
          this.selValves.length > 0 &&
          this.levelType === "subnível" &&
          this.selValves.length < this.listValves.length &&
          this.selValves.some((e) => e.PUMP_NAME !== null)
        ) {
          this.listValves = this.showValvesWithSamePumpName(regexFIR);
        }
        //Quando não tiver carregado o listValves mas já possuir as válvunas no selValves,
        // Ou seja, usado para carregar os listValves fitrando por PUMP_NAME e NAME_MODEL não sendo
        // Ferti.
        else if (
          this.hasFerti &&
          this.selValves.length > 0 &&
          !this.listValves.length
        ) {
          this.listValves = this.showValvesWithSamePumpName(regexFIR);
        }
        //Quando for editar um subnível da agenda não ferti e não tiver selecionado nenhuma válvula,
        // Irá pegar o último valor da válvula selecionada no checkbox para ter como base para exibir somente as válvulas
        // Com o mesmo PUMP_NAME, não permitindo trocar por qualquer outra válvula com modelo diferente.
        else if (
          this.hasFerti &&
          this.selValves.length === 0 &&
          this.levelType === "subnível"
        ) {
          this.listValves = this.showValvesWithSamePumpName(regexFIR);
        }
        // Editar nível
        else if (this.levelType === "nível") {
          this.listValves = this.filterValvesWithNameModel(regexFIR, false);
        }
        // Editando SUBNÍVEL que não possui ferti
        else if (this.levelType === "subnível" && !this.hasFerti) {
          this.listValves = this.filterValvesWithNameModel(regexFIR, false);
        }
        //Editar Ferti exibindo somente FERTI
        else if (this.levelType === "ferti") {
          this.listValves = this.filterValvesWithNameModel(regexFIR, true);
        }
      }
      // ADICIONAR FERTI NA AGENDA
      else if (this.levelType === "ferti") {
        this.listValves = this.filterValvesWithNameModel(regexFIR, true);
      }
      // ADICIONAR SUBNÍVEL NA AGENDA com ferti filtrando por válvulas com o mesmo PUMP_NAME
      else if (
        this.hasFerti &&
        this.selValves.length > 0 &&
        this.levelType === "subnível" &&
        this.selValves.length < this.listValves.length &&
        this.selValves.some((e) => e.PUMP_NAME !== null)
      ) {
        this.listValves = this.showValvesWithSamePumpName(regexFIR);
      }
      //Quando For adicionar uma válvula no subnível e desmarcar todas as
      // válvulas selecionadas, terá que continuar a filtrar por PUMP_NAME
      // pois um subnível com ferti não pode ser trocado por outras válvulas.
      else if (
        this.hasFerti &&
        this.selValves.length === 0 &&
        this.levelType === "subnível"
      ) {
        this.listValves = this.showValvesWithSamePumpName(regexFIR);
      }
      // ADICIONAR OUTRAS VÁLVULAS
      else {
        this.listValves = this.filterValvesWithNameModel(regexFIR, false);
      }
    },
    formatDateTime(date, time) {
      if (date && time) {
        let datetime = `${date} ${time}`;
        return moment(datetime, "YYYY-MM-DD HH:mm:ss").format(
          "DD/MM/YYYY HH:mm"
        );
      }
      return;
    },
    makeValvesArr() {
      let list = [];
      this.selectedItem.sublevels.map((e) => list.push(e));
      return list;
    },
    organizeSublevelsToShow(schedule) {
      if (this.formType == "edit" || this.formType == "duplicate") {
        this.form.sublevels = schedule.sublevels ? this.makeValvesArr() : [];
        this.levels = schedule.sublevels ? this.makeValvesArr() : [];
      }
      if (schedule && schedule.sublevels && schedule.sublevels.length) {
        let levels = schedule.sublevels
          .map((e) => e.LEVEL)
          .filter((e, i, arr) => arr.indexOf(e) == i);
        this.selectedLevelPosition = Math.max(...levels) + 1;
        this.levelPositionsSelector = [...levels, Math.max(...levels) + 1];
      } else {
        this.levelPositionsSelector = [1];
        this.selectedLevelPosition = 1;
      }
      this.typeOpt = "lvl";
    },
    // CARREGAR AS VÁLVULAS SELECIONADAS
    inheritedSelection(selected, valves) {
      if (this.isFerti) {
        this.selValves = valves.filter(
          (e) => e.NAME == selected.ELEMENTS[0].NAME
        );
        this.valvesItemsFormCheckbox();
      } else {
        let selElementsId = [];
        if (selected && selected.ELEMENTS && selected.ELEMENTS.length)
          selElementsId = selected.ELEMENTS.map((e) => e.ID);
        this.selValves = valves.filter((e) => selElementsId.includes(e.ID));
        this.valvesItemsFormCheckbox();
      }
    },
    resetForm() {
      this.step = 1;
      this.form = {
        NAME: "",
        START_DATE: "",
        START_TIME: "",
        END_DATE: "",
        END_TIME: "",
        ACTIVITY_DAYS: 127,
        sublevels: [],
        FK_SENSOR: null,
        POS_SENSOR: null,
        ACTION_SENSOR: null,
        MAX_SENSOR: null,
        MIN_SENSOR: null,
        PEAK_HOUR_BLOCK: false,
      };
      this.levels = [];
      this.ends = false;
      this.conditional = false;
      this.selDays = [1, 1, 1, 1, 1, 1, 1];
      this.fertilevels = [];
      this.pumpFilterTitle = "Todas as válvulas";
      this.agnlevel = 0; //por padrão zero para adição
    },
    //auxiliar para estado de input
    activeDay(idx) {
      if (this.selDays[idx]) this.form.ACTIVITY_DAYS -= this.days[idx].value;
      else this.form.ACTIVITY_DAYS += this.days[idx].value;
      this.selDays[idx] = !this.selDays[idx];
      this.$forceUpdate();
    },
    activityDays() {
      let decDays = this.selectedItem.ACTIVITY_DAYS;
      for (let i = 6; i >= 0; i--) {
        if (decDays - this.days[i].value >= 0) {
          decDays -= this.days[i].value;
          this.selDays[i] = 1;
        } else this.selDays[i] = 0;
      }
    },
    formatDays() {
      return this.selDays
        .map(
          (e, i) =>
            `<span style='color:${!!e ? "#7AB648" : "#DC3545"}'>${
              this.days[i].text
            }</span>`
        )
        .join(" ");
    },
    checkForm() {
      this.errors = [];
      let states = [
        this.nameState,
        this.notRepeatedName,
        this.checkConditional,
      ];
      let erros = [
        "Nome é obrigatório. Permitidos apenas letras, números, pontos, hífens e underlines. Espaços NÃO são permitidos.",
        "Nome escolhido já está em uso. Verifique.",
        "Verifique a condição de operação.",
      ];
      states.map((e, i) => {
        if (!e) {
          this.errors.push(erros[i]);
        }
      });
      let start = `${this.form.START_DATE} ${this.form.START_TIME}`;
      let end = `${this.form.END_DATE} ${this.form.END_TIME}`;
      if (!start.trim() || !this.form.START_DATE || !this.form.START_TIME) {
        this.errors.push(
          "Uma data de início completa é obrigatória para agendas."
        );
      } else if (this.ends) {
        if (!end.trim() || !this.form.END_DATE || !this.form.END_TIME) {
          this.errors.push(
            "Em caso de expiração, deve-se indicar uma data completa para tal."
          );
        } else if (start > end) {
          this.errors.push(
            "Data de expiração não pode vir antes da data de início da agenda."
          );
        } else if (start == end) {
          this.errors.push("Datas de início e fim não podem ser as mesmas.");
        }
      }
      if (this.errors.length) this.$refs.formError.show();
      else {
        if (this.formType == "add") {
          this.resetMenus();
        }
        if (!this.ends) {
          this.form.END_DATE = null;
          this.form.END_TIME = null;
        }
        this.step = 2;
      }
    },
    // events level form
    onSetLevel(level) {
      this.agnlevel = level;
    },
    onLevelRemove(newList) {
      this.form.sublevels = newList;
      this.levels = newList;
      this.agnlevel--;
      this.typeOpt = "lvl";
      this.resetMenus();
    },
    onLevelEdit(idx, hasFerti, div) {
      let selected = this.form.sublevels[idx];
      this.hasFerti = hasFerti;
      this.levelForm.TIME = selected.duration.TIME;
      this.allDay = selected.duration.TIME == 1440;
      this.levelForm.ADVANCE_TIME = selected.duration.ADVANCE_TIME;
      this.levelForm.MIN_TIME = selected.duration.MIN_TIME;
      this.levelForm.VOLUME = selected.duration.VOLUME;
      this.levelForm.index = idx;
      this.whereToScroll = div;
      this.levelForm.selected = selected;
      this.levelCreator("edit", this.selectedLevelPosition, "sub");
    },
    onFertiAdd(idx, element, div) {
      this.resetLevelEditor();
      let selected = this.form.sublevels[idx].FERTI;
      this.fertilevels = selected;
      this.levelForm.levelIndex = idx;
      this.whereToScroll = div;
      this.levelCreator("add", null, "sub", element);
    },
    onLevelWithFertiEdit() {
      this.hasFerti = true;
    },
    onFertiEdit(params, element, div) {
      let levelIndex = params.levelIndex;
      let fertilevel = params.fertilevel;
      let selected = this.form.sublevels[levelIndex].FERTI.filter(
        (e) => e.FERTILEVEL == fertilevel
      )[0];
      this.fertilevels = this.form.sublevels[levelIndex].FERTI;
      this.levelForm.TIME = selected.duration.TIME;
      this.allDay = selected.duration.TIME == 1440;
      this.levelForm.ADVANCE_TIME = selected.duration.ADVANCE_TIME;
      this.levelForm.MIN_TIME = selected.duration.MIN_TIME;
      this.levelForm.VOLUME = selected.duration.VOLUME;
      this.levelForm.levelIndex = levelIndex;
      this.whereToScroll = div;
      this.levelForm.selected = selected;
      this.levelCreator("edit", null, "sub", element);
    },
    onFertiRemove(newList) {
      this.form.sublevels = newList;
      // this.levels = newList;
    },
    backToGeneral() {
      this.cancelLevelPage();
      this.step = 1;
    },
    cancelLevelPage() {
      this.isLevelForm = false;
      this.resetMenus();
      this.resetLevelEditor();
    },
    // step 2
    checkMenu(e) {
      if (e == "sub") {
        this.levelPositionsSelector = Array(this.agnlevel)
          .fill(0)
          .map((e, i) => i + 1);
        this.selectedLevelPosition = this.agnlevel;
      } else if (e == "lvl") {
        this.resetMenus();
      }
    },
    resetMenus() {
      this.levelPositionsSelector = [
        ...Array(this.agnlevel)
          .fill(0)
          .map((e, i) => i + 1),
        this.agnlevel + 1,
      ];
      this.selectedLevelPosition = this.agnlevel + 1;
      this.typeOpt = "lvl";
    },
    calcDuration(duration, advance) {
      return duration - advance;
    },
    resetLevelEditor() {
      this.hasFerti = false;
      this.isFerti = false;
      this.allDay = false;
      this.levelForm = {
        TIME: 0,
        ADVANCE_TIME: 0,
        VOLUME: 0,
        MIN_TIME: 0,
      };
      this.selValves = [];
      this.pumps = [];
    },
    levelCreator(action, level, type, ferti) {
      if (type == "sub") {
        if (action == "add") {
          // add subnível
          if (ferti) {
            this.isFerti = true;
            this.isFertiAdd = true;
            this.levelPageTitle = "Adicionar subnível de fertirrigação";
            this.levelType = "ferti";
          } else {
            this.isFerti = false;
            this.levelPageTitle = `Adicionar subnível ao nível ${level}`;
            this.levelType = "subnível";
            this.resetLevelEditor();
          }
        } else if (action == "edit") {
          // edit subnível
          if (ferti) {
            this.isFerti = true;
            this.isFertiAdd = false;
            this.levelPageTitle = "Editar subnível de fertirrigação";
            this.levelType = "ferti";
          } else {
            this.isFerti = false;
            this.levelPageTitle = "Editar subnível";
            this.levelType = "subnível";
          }
        }
      } else {
        // add novo nível
        this.isFerti = false;
        this.isFertiAdd = false;
        this.levelPageTitle = `Adicionar nível ${level}`;
        this.levelType = "nível";
        this.resetLevelEditor();
      }
      this.sublevel = type == "sub";
      this.valves = [];
      this.valvesReq = [];
      this.loadingValves = true;
      schedules
        .getConnecteds(ferti)
        .then((ret) => {
          if (ferti) alert(ret.log, ret.alert);
          // PIR só nas agendas do próprio pivô (aba Agenda do PIR); o backend
          // também recusa (schedule/Model.js, rejectPirValves).
          const valves = (ret.value || []).filter(
            (v) => !["PIR", "DIR-PIR"].includes(v.NAME_MODEL)
          );
          this.valves = valves;
          this.valvesReq = valves;
          this.loadingValves = false;
          this.valvesItemsFormCheckbox();
          if (this.valves.length) {
            this.pumps = this.valves.map((e) => e.PUMP_NAME).filter((e) => !!e);
            if (this.pumps.length)
              this.pumps = this.pumps.filter(
                (e, i, arr) => arr.indexOf(e) == i
              );
            if (this.pumpFilterTitle != "Todas as válvulas")
              this.filterByPump(this.pumpFilterTitle);
          }
          if (action == "edit" && this.valvesReq.length)
            this.inheritedSelection(this.levelForm.selected, this.valvesReq);
        })
        .catch((err) => {
          console.error("Erro ao aplicar filtros nas válvulas.");
          console.error(err);
        });
      // this.$refs.levelCreation.show();
      this.isLevelForm = true;
    },
    allDaySelected(e) {
      let values = [0, 1440];
      this.levelForm.TIME = values[Number(e)];
      this.calculatePulseTime = "pulse";
      this.isSelectDisabled =
        this.selValves.length !== 1 || this.levelForm.TIME === 1440;
    },
    levelAdd(type) {
      //'salva' o level
      // levelDurationVolumeState só é relevante pro subnível de ferti (campo
      // Volume nem aparece fora desse fluxo) -- faltava aqui, então um volume
      // acima do máximo (rate-based, até 4095 l) passava mesmo com o campo
      // marcado como inválido na tela.
      if (
        this.levelDurationState &&
        this.selValves.length &&
        (!this.isFerti || this.levelDurationVolumeState)
      ) {
        if (this.isFerti) {
          if (this.selValves.length < 2) {
            let levelSelected = this.form.sublevels[this.levelForm.levelIndex];
            if (this.levelForm.selected) {
              let level = this.levelForm.selected.LEVEL || levelSelected.LEVEL;
              let group = this.levelForm.selected.GROUP || levelSelected.GROUP;
              let fertilevel = this.levelForm.selected.FERTILEVEL;
              let fertiindex = fertilevel - 1;
              this.fertilevels.splice(fertiindex, 1, {
                duration: {
                  MIN_TIME: this.levelForm.MIN_TIME,
                  ADVANCE_TIME: this.levelForm.ADVANCE_TIME,
                  TIME: this.levelForm.TIME,
                  VOLUME: this.levelForm.VOLUME,
                },
                ELEMENTS: this.selValves,
                COUNT: this.selValves.length,
                FERTILEVEL: fertilevel,
                LEVEL: level,
                GROUP: null,
                // GROUP: group,
              });
            } else {
              this.fertilevels.push({
                duration: {
                  MIN_TIME: this.levelForm.MIN_TIME,
                  ADVANCE_TIME: this.levelForm.ADVANCE_TIME,
                  TIME: this.levelForm.TIME,
                  VOLUME: this.levelForm.VOLUME,
                },
                ELEMENTS: this.selValves,
                COUNT: this.selValves.length,
                FERTILEVEL: this.fertilevels.length + 1,
                LEVEL: levelSelected.LEVEL,
                GROUP: null,
                // GROUP: levelSelected.GROUP,
              });
            }
            this.form.sublevels[this.levelForm.levelIndex].FERTI =
              this.fertilevels;
            this.fertilevels = [];
            this.resetMenus();
            this.isLevelForm = false;
          }
        } else {
          if (this.levelForm.selected) {
            //editting level
            let level = this.levelForm.selected.LEVEL;
            let group = this.levelForm.selected.GROUP;
            let ferti = this.levelForm.selected.FERTI;
            let index = this.levelForm.index;
            delete this.levelForm.selected;
            delete this.levelForm.index;
            let info = {
              duration: {
                MIN_TIME: this.levelForm.MIN_TIME,
                ADVANCE_TIME: this.levelForm.ADVANCE_TIME,
                TIME: this.levelForm.TIME,
                VOLUME: this.levelForm.VOLUME,
              },
              ELEMENTS: this.selValves,
              FERTI: ferti,
              COUNT: this.selValves.length,
              LEVEL: level,
              GROUP: group,
            };
            this.levels.splice(index, 1, info);
          } else {
            // adding level
            let currentLevel = this.selectedLevelPosition;
            let levels = this.levelPositionsSelector;
            let numOfLevels = levels.length;
            let isLast = currentLevel == levels[numOfLevels - 1];
            let info = {
              duration: {
                MIN_TIME: this.levelForm.MIN_TIME,
                ADVANCE_TIME: this.levelForm.ADVANCE_TIME,
                TIME: this.levelForm.TIME,
                VOLUME: this.levelForm.VOLUME,
              },
              ELEMENTS: this.selValves,
              FERTI: [],
              COUNT: this.selValves.length,
              LEVEL: currentLevel,
              GROUP: currentLevel,
            };
            if (type == "lvl") {
              this.agnlevel++;
              if (isLast) {
                this.levels.push(info);
                this.whereToScroll = `group${this.levels.length - 2}`;
              } else {
                let lvls = this.levels.map((e) => e.LEVEL);
                let newIndex = lvls.indexOf(currentLevel);
                this.levels.splice(newIndex, 0, info);
                this.whereToScroll = newIndex ? `group${newIndex}` : "";
                this.levels.forEach((e, i) => {
                  if (i > newIndex) {
                    e.LEVEL++;
                    e.GROUP++;
                    //Atualizar os LEVELS do ELEMENTS
                    if (e.ELEMENTS) {
                      e.ELEMENTS.forEach((el) => {
                        el.LEVEL = e.LEVEL;
                        el.GROUP++;
                      });
                    }
                    if (e.FERTI) {
                      e.FERTI.forEach((ferti) => {
                        ferti.LEVEL = e.LEVEL;
                        ferti.GROUP = null;
                      });
                    }
                  }
                });
              }

              this.afterAddLevelManagementData = this.previewManagementData;
            } else if (type == "sub") {
              let lvls = this.levels.map((e) => e.LEVEL);
              let newIndex = lvls.indexOf(currentLevel + 1);
              this.whereToScroll = newIndex ? `group${newIndex}` : "";

              this.levels.splice(newIndex, 0, info);
            }
          }
          this.form.sublevels = this.levels;
          this.resetMenus();
          this.isLevelForm = false;
        }
      }
    },
    calcHistoricVolPerValve(valve) {
      let idealVol = 0;

      if (this.levelForm.TIME) {
        let flow = this.flows[valve.ID] || 0;
        if (flow) {
          let time = this.levelForm.TIME;
          let hours = time / 60;
          idealVol = hours * flow;
        }
      }
      return idealVol ? idealVol.toFixed(2) : 0;
    },
    calcIdealVolPerValve(valve) {
      let idealVol = 0;

      if (this.levelForm.TIME) {
        if (valve.MAX_FLOW > 0 && valve.MIN_FLOW > 0) {
          let sum = valve.MAX_FLOW + valve.MIN_FLOW;
          let flow = sum / 2;
          let time = this.levelForm.TIME;
          let hours = time / 60;

          idealVol = hours * flow;
        }
      }

      return idealVol ? idealVol.toFixed(2) : 0;
    },
    calcVolBlade(vol, valve, area, hectare) {
      let idealVol = (vol / (area * hectare)) * 1000;

      return idealVol ? idealVol.toFixed(2) : 0;
    },
    toggleAllValves(checked) {
      this.allValveSelected = checked;
      if (this.selValves.length < this.listValves.length) {
        this.selValves = this.allValveSelected ? this.listValves : [];
      } else if (this.selValves.length == this.listValves.length) {
        this.selValves = [];
      }
    },
    filterByPump(pump) {
      this.pumpFilterTitle = pump || "Todas as válvulas";
      if (pump) {
        this.valves = this.valvesReq.filter((e) => e.PUMP_NAME == pump);
        this.valvesItemsFormCheckbox();
      } else {
        this.valves = this.valvesReq.map((e) => e);
        this.valvesItemsFormCheckbox();
      }
      this.$refs.pumpFilter && this.$refs.pumpFilter.hide();
    },
    selectInterval() {
      let interval = this.valvesReq.filter((e) => e.NAME == "INTERVALO")[0];
      this.$refs.pumpFilter.hide();
      this.selValves.push(interval);
      this.$refs.formEquipments.hide();
    },
    submit(event) {
      this.disableBtnSubmit = true;
      return this.validateForm(this.form).then((form) => {
        this.$emit("submit", form);
      });
      // this.$emit("close-form");
    },
    validateForm(form) {
      return new Promise((resolve) => {
        if (this.agnlevel) form.LEVELS = this.agnlevel;
        if (!this.ends && (form.END_DATE !== null || form.END_TIME !== null)) {
          form.END_DATE = null;
          form.END_TIME = null;
        }
        resolve(form);
      });
    },
  },
};
</script>

<style scoped>
.peak-hour-info {
  font-size: 0.75em;
  color: var(--text-gray-primary);
  margin: 2px 0 8px;
}
.data-form {
  margin-top: 0.6em;
  padding: 0 1em 20px 1em;
}
#form > div {
  display: flex;
  height: 100%;
  flex-direction: column;
}
.content-description {
  font-family: "SourceSansPro_Regular", Arial, Helvetica, sans-serif;
  font-size: 0.9em;
  margin-bottom: 9px;
  color: var(--text-gray-primary);
  padding: 1em;
  background-color: #fdfdfd;
  border-radius: 4px;
  border: solid 1px var(--border-grey-color-primary);
}
strong {
  font-family: "SourceSansPro_Bold", Arial, Helvetica, sans-serif;
  color: var(--text-gray-primary);
}
.level-page-title {
  font-size: 1em;
}
.levels {
  margin-top: 5px;
  margin-bottom: 1.5em;
}
.schedule-form-levels {
  position: relative;
  /* padding-top: 25px; */
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  overflow-y: auto;
  margin-top: 0px;
  padding: 0px;
  margin-bottom: 100px;
}
.schedule-form-levels .content {
  padding: 0 1em;
  margin-top: 0.6em;
}
.schedule-form-title,
.schedule-form-toolbar {
  background-color: #fff;
  z-index: 99;
}
.modal-items {
  font-size: 0.8em;
}
.schedule-form-title {
  /* position: fixed; */
  width: 100%;
  top: 67px;
  padding: 0.6em 0;
  margin-left: 0px;
  color: var(--text-gray-primary);
  text-align: center;
  word-break: break-word;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-bottom: 1px solid #eee;
  /* margin-bottom: 1em; */
}
.schedule-form-title .form-header {
  font-family: "SourceSansPro_Semibold", Arial, Helvetica, sans-serif;
  /* font-size: 1.15em; */
  text-overflow: ellipsis;

  margin: 0px;
  padding: 0;
  /* height: 100%; */
}
.schedule-form-toolbar {
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  /* top: 28px; */
  margin-left: 0;
  width: 100%;
  padding: 5px 0px;
  margin-top: -1px;
}
.schedule-form-toolbar:last-child {
  display: none;
}
.buttons-icons {
  display: flex;
  justify-content: center;
  align-items: center;
}
.buttons-icons .material-design-icon {
  margin-bottom: 4px;
  font-size: 1.3em;
}
.equipment-table {
  height: 310px !important;
  overflow-x: hidden;
  overflow-y: auto;
}
.ferti-error {
  font-size: 0.8rem;
  color: #dc3545;
}
.selected-box {
  height: auto !important;
}
.selected-item {
  overflow: hidden;
  margin-bottom: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.selected-property {
  text-transform: none !important;
}
.title-section {
  /* font-family:"SourceSansPro_Semibold",Arial, Helvetica, sans-serif ; */
  margin-top: 10px;
  margin-bottom: 5px;
  font-size: 0.9em;
}
#form {
  max-height: 100vh;
  padding: 0;
  display: flex;
  flex-direction: column;
  margin-top: 55px;
}

#form footer,
#details header,
#details footer {
  position: absolute;
  bottom: 58px;
  bottom: 70px;
}
footer .go-back {
  display: flex;
  align-items: center;
  justify-content: center;
}
footer .go-back .material-design-icon {
  font-size: 1.3em;
  margin-bottom: 4px;
  margin-right: 4px;
}
.edit-button {
  display: flex;
  align-items: center;
  justify-content: center;
}
.edit-button .material-design-icon {
  font-size: 1.1em;
  margin-bottom: 4px;
  margin-right: 5px;
}
@media (max-width: 991px) {
  #form {
    max-height: 100vh;
    /* border: 5px solid red; */
  }
  #footer {
    margin-bottom: 50px;
    height: 35px;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  /* #form footer {
    z-index: 1000000000000000;
    background-color: red;
    position: fixed;
    bottom: 4px;
  } */
}
@media (max-width: 767px) {
  #form {
    padding: 0;
    margin-top: 0px;
  }
  #form > div {
    display: flex;
    height: 100%;
    flex-direction: column;
  }
  #form,
  #details {
    padding-top: 0.1em;
  }
  #form footer,
  #details header,
  #details footer {
    position: absolute;
    bottom: 4px;
  }
  .schedule-form-levels {
    margin-bottom: 48px;
  }
}

.table-agn >>> .text-aln-center,
.table-agn >>> tr > * {
  text-align: center !important;
  vertical-align: middle !important;
}

.table-agn >>> .good-water [aria-colindex="2"],
.table-agn >>> .low-water [aria-colindex="2"],
.table-agn >>> .extra-water [aria-colindex="2"] {
  position: relative;
}

.table-agn >>> .good-water [aria-colindex="2"]::after,
.table-agn >>> .low-water [aria-colindex="2"]::after,
.table-agn >>> .extra-water [aria-colindex="2"]::after {
  content: "";
  position: absolute;
}

.table-agn >>> .extra-water [aria-colindex="2"]::after {
  margin-left: 0.5rem;
  border: solid var(--blue-color-primary);
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
  margin-top: 0.6rem;
  right: 8px;
}

.table-agn >>> .low-water [aria-colindex="2"]::after {
  margin-left: 0.5rem;
  border: solid var(--red-color-primary);
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  margin-top: 0.3rem;
  -webkit-transform: rotate(45deg);
  right: 8px;
}

.table-agn >>> .good-water [aria-colindex="2"]::after {
  display: inline-block;
  transform: rotate(45deg);
  height: 12px;
  width: 6px;
  margin-left: 60%;
  border-bottom: 3px solid #78b13f;
  margin-top: 0.2rem;
  border-right: 3px solid #78b13f;
  right: 12px;
}

.accordion button.btn.btn-3v3 > .arrow-suffix {
  content: "";
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #dffad0;
  font-size: 0;
  line-height: 0;
  transition: transform 0.4s;
}

.accordion button.btn.btn-3v3:not(.collapsed) > .arrow-suffix {
  transform: rotate(-90deg);
}

.schedule-management-details li:before {
  content: "• ";
}
</style>
